import type { AmendmentsFilter } from '../models';
import { useState } from 'react';

const AMENDMENTS_FILTERS_STORAGE_KEY = 'amendmentsFilters';

const parseIsoDateFromJson = (value: unknown): Date | null => {
  if (value == null || value === '') return null;
  const parsed = new Date(value as string);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const getStoredAmendmentsFilter = (): AmendmentsFilter => {
  const raw = localStorage.getItem(AMENDMENTS_FILTERS_STORAGE_KEY);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return {
      shippingNumber: typeof parsed.shippingNumber === 'string' ? parsed.shippingNumber : undefined,
      transitionId: typeof parsed.transitionId === 'string' ? parsed.transitionId : undefined,
      from: parseIsoDateFromJson(parsed.from),
      to: parseIsoDateFromJson(parsed.to),
    };
  } catch {
    return {};
  }
};

export const useAmendmentsFilter = () => {
  const [filter, setFilterState] = useState<AmendmentsFilter>(() =>
    getStoredAmendmentsFilter()
  );

  const setFilter = (newFilter: AmendmentsFilter) => {
    setFilterState(newFilter);
    try {
      localStorage.setItem(
        AMENDMENTS_FILTERS_STORAGE_KEY,
        JSON.stringify({
          shippingNumber: newFilter.shippingNumber,
          transitionId: newFilter.transitionId,
          from: newFilter.from instanceof Date ? newFilter.from.toISOString() : newFilter.from,
          to: newFilter.to instanceof Date ? newFilter.to.toISOString() : newFilter.to,
        })
      );
    } catch {
    }
  };

  return { filter, setFilter };
};
